module.exports = __webpack_public_path__ + "static/media/header_russia.6c385467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/header_russia.png
// module id = 296
// module chunks = 0